export default __webpack_public_path__ + "static/media/ios_code.58d82f0e.png";